import { DefaultChangePaidMembershipPlanRepository } from '@/models/api/paid-member-price/member-plan/change/repository'
import {
  DefaultAvailableMembershipPlanGroupRepository
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group-repository'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ScopeKind, ScopeValue } from '@/models/cart/group/scope'
import { CartItemRepository } from '@/models/cart/repository/cart-item-repository'
import { EngineCartRepository } from '@/models/cart/repository/impl/cart-item/engine-cart-item-repository'
import { DefaultSubscriptionApplyingItemRepository } from '@/models/order/subscription/applying-item/repository/default-subscription-applying-item-repository'
import {
  purchaseContext,
  subscriptionContext,
} from '@/models/payment/creditcard/service/register-new-creditcard/dependencies'
import { ApiPointListRepository } from '@/models/point/list/point-list-repository'
import { multiInstanceContext, singleInstanceContext } from '@/page/context/instance'
import { createBrandPageContext, crossBrandPageContext, hostPageContext } from '@/page/context/page'
import { SubscriptionService } from '@/services/api/subscription'
import { SubscriptionApplyingItemService } from '@/services/api/subscription/subscription-applying-item'
import { PointService } from '@/services/point'
import PaidMembershipPlansPage from '@spa/components/pages/mypage/paid-membership/plans/PaidMembershipPlansPage.vue'
import Point from '@spa/components/pages/mypage/point/Point.vue'
import ContractedSubscriptionDetailPage from '@spa/components/pages/mypage/subscription/contracted/detail/ContractedSubscriptionDetailPage.vue'
import EditPaymentForSubscription from '@spa/components/pages/mypage/subscription/contracted/detail/edit/payment/EditPaymentForSubscription.vue'
import ContractedSubscriptionListPage from '@spa/components/pages/mypage/subscription/contracted/list/ContractedSubscriptionListPage.vue'
import { OnceOrderContext } from '@spa/components/pages/order/model/context/once-order/once-order-context'
import { SubscriptionContext } from '@spa/components/pages/order/model/context/subscription/subscription-context'
import {
  selectLocatorByScope as selectOrderCompleteLocatorByScope
} from '@spa/components/pages/order/model/order-complete/service-locator'
import {
  selectLocatorByScope as selectOrderLocatorByScope
} from '@spa/components/pages/order/model/order/service-locator'
import { guardOnCart } from '@spa/components/pages/order/routing/guard'
import { toScope } from '@spa/components/pages/order/scope-transpiler'
import ChangeCreditcard from '@spa/components/pages/paid-membership/change/ChangeCreditcard.vue'
import ChangePlan from '@spa/components/pages/paid-membership/change/ChangePlan.vue'
import {
  NextPageAfterCardRegistration
} from '@spa/components/pages/paid-membership/change/model/change-creditcard/next-page'
import { ChangePlanInteraction } from '@spa/components/pages/paid-membership/change/model/interaction'
import { downgradePageBuilder } from '@spa/components/pages/paid-membership/change/model/page/downgrade-page-builder'
import { upgradePageBuilder } from '@spa/components/pages/paid-membership/change/model/page/upgrade-page-builder'
import { Context } from '@spa/components/pages/paid-membership/subscribe/interaction/context'
import Confirm from '@spa/components/pages/paid-membership/unsubscribe/confirm/Confirm.vue'
import UnsubscribePaidMembership from '@spa/components/pages/paid-membership/unsubscribe/Unsubscribe.vue'
import {
  ContextToRegisterNewCreditCard,
  reloadCreditcardForPurchase, reloadCreditcardForSubscription,
} from '@spa/components/pages/payment/creditcard/new-creditcard/context'
import ApplySubscription from '@spa/components/pages/subscription/ApplySubscription.vue'
import SubscriptionEditPayment from '@spa/components/pages/subscription/edit/payment/Index.vue'
import SubscriptionOrderComplete from '@spa/components/pages/subscription/OrderComplete.vue'
import { getAuthViewFor } from '@spa/router/hooks/auth/view-definitions/definitions'
import {
  beforeEnterCartAuth,
  propsForCartLogin,
  propsForCartSignup,
} from '@spa/router/hooks/cart/auth/cart-auth-routing-hook'
import { propsForCart } from '@spa/router/hooks/cart/props-for-cart'
import { guardOnBrandScope } from '@spa/router/hooks/cart/scope/guard-on-brand-scope'
import { guardOnCrossBrandScope } from '@spa/router/hooks/cart/scope/guard-on-cross-brand-scope'
import { isSinglePurchasable, isSubscriptionItem } from '@spa/store/modules/cart/function'
import Vue from 'vue'
import Router, { Route, RouteConfig } from 'vue-router'

import { log } from '@/log'
import { HOST_ID } from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import { sendLog as sendPcpAnalyticsLog } from '@/vendor/pcp-analytics'
import { ContactOnMyPageContext } from '../components/organisms/contact/model/context/contact-on-my-page/contact-on-my-page-context'
import Logout from '../components/pages/auth/logout/Logout.vue'
import ForgotPassword from '../components/pages/auth/reset/ForgotPassword.vue'
import ResetPassword from '../components/pages/auth/reset/ResetPassword.vue'
import Cart from '../components/pages/cart/Cart.vue'
import CartList from '../components/pages/cart/CartList.vue'
import NotFound from '../components/pages/error/NotFound.vue'
import Inquiry from '../components/pages/inquiry/Inquiry.vue'
import MyPageCaratAddProfile from '../components/pages/mypage/carat/AddProfile.vue'
import MyPageCarat from '../components/pages/mypage/carat/Index.vue'
import CatalogRegister from '../components/pages/mypage/CatalogRegister.vue'
import Coupon from '../components/pages/mypage/coupon/Coupon.vue'
import ChangeMailMagazine from '../components/pages/mypage/edit/ChangeMailMagazine.vue'
import MyPageEditPassword from '../components/pages/mypage/edit/ChangePassword.vue'
import MyPageEditEachContact from '../components/pages/mypage/edit/contact/Contact.vue'
import MyPageEditContact from '../components/pages/mypage/edit/contact/Index.vue'
import MyPageEditNewContact from '../components/pages/mypage/edit/contact/NewContact.vue'
import MyPageEditProfile from '../components/pages/mypage/edit/UpdateProfile.vue'
import MycolorItems from '../components/pages/mypage/MyColorItems.vue'
import MyPageOrderHistory from '../components/pages/mypage/order/History.vue'
import MyPageOrderHistoryDetail from '../components/pages/mypage/order/HistoryDetail.vue'
import MyPageOrderHistoryDetailCancel from '../components/pages/mypage/order/HistoryDetailCancel.vue'
import MyPageOrderHistoryDetailCanceled from '../components/pages/mypage/order/HistoryDetailCanceled.vue'
import ReorderCreditcard from '../components/pages/mypage/order/reorder/ReorderCreditcard.vue'
import ReorderPayment from '../components/pages/mypage/order/reorder/ReorderPayment.vue'
import ReorderProfile from '../components/pages/mypage/order/reorder/ReorderProfile.vue'
import UsualPowerSettings from '../components/pages/mypage/power-settings/UsualPowerSettingsPage.vue'
import SubscriptionPaymentHistory from '../components/pages/mypage/subscription/payment-history/SubscriptionPaymentHistory.vue'
import MyPage from '../components/pages/mypage/Top.vue'
import OrderEditEachContact from '../components/pages/order/edit/contact/Contact.vue'
import OrderEditContact from '../components/pages/order/edit/contact/Index.vue'
import OrderEditNewContact from '../components/pages/order/edit/contact/NewContact.vue'
import OrderEditPayment from '../components/pages/order/edit/payment/Index.vue'
import MinimumUpdateProfile from '../components/pages/order/MinimumUpdateProfile.vue'
import Order from '../components/pages/order/Order.vue'
import OrderComplete from '../components/pages/order/OrderComplete.vue'
import OrderCompleteById from '../components/pages/order/OrderCompleteById.vue'
import UnexpectedCreditcardRegsiterError from '../components/pages/paid-membership/error-page/UnexpectedCreditcardRegsiterError.vue'
import CompleteSubscribe from '../components/pages/paid-membership/subscribe/CompleteSubscribe.vue'
import SubscribePaidMembership from '../components/pages/paid-membership/subscribe/Subscribe.vue'
import NewCreditcard from '../components/pages/payment/creditcard/NewCreditcard.vue'
import { executeUniversalTag } from '../vendor/cribnotes.js'
import * as RouteHook from './hooks'

const isSingleInstance = InstanceResolver.isSingle()

const authViewDefinition = getAuthViewFor(BehaviorConfig.forHost)

/**
 * FIXME:
 * https://github.com/my-color/front/pull/465#issuecomment-460954186
 * /order配下のページ、および /cart/login, /cart/signup ではクエリキーとしてブランド名を引回す用に設定しているが、
 * スケジュール都合＋作業/影響範囲抑制のための暫定的対策.
 *
 * 本来的には、恐らくqueriesToBeKeptを指定しているページもブランドページ配下にするべきと思われるが、
 * 作業範囲/影響範囲共に広くなってしまい作業時間が長引くことが予想されるため、
 * クエリパラメータを引回すことで強引にブランド情報を維持する対策を取った.
 *
 * p2.2.0の次または次々フェーズまでにはこの状態を解消したい.
 */

const commonRoutes: RouteConfig[] = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    component: authViewDefinition.layout.login,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.default.login,
      },
    }],
    props: route => ({
      next: route.query.next,
    }),
    meta: {
      queriesToBeKept: '*',
    },
  },
  {
    path: '/signup',
    component: authViewDefinition.layout.signup,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.default.signup,
      },
    }],
    props: route => ({
      next: route.query.next,
    }),
    meta: {
      queriesToBeKept: '*',
    },
  },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/logout', component: Logout },
  { path: `/reset_password/${HOST_ID}/:token`, component: ResetPassword },
  { path: '/inquiry', component: Inquiry },
  { path: '/mypage', component: MyPage, meta: { requireLogin: true } },
  { path: '/mypage/mycolor-items', component: MycolorItems, meta: { requireLogin: true } },
  { path: '/mypage/carat', component: MyPageCarat, meta: { requireLogin: true } },
  { path: '/mypage/carat/add-profile', component: MyPageCaratAddProfile, meta: { requireLogin: true } },
  { path: '/mypage/coupons', component: Coupon, meta: { requireLogin: true } },
  { path: '/mypage/edit/profile', component: MyPageEditProfile, meta: { requireLogin: true } },
  { path: '/mypage/edit/password', component: MyPageEditPassword, meta: { requireLogin: true } },
  { path: '/mypage/edit/mail-magazine', component: ChangeMailMagazine, meta: { requireLogin: true } },
  { path: '/mypage/order', component: MyPageOrderHistory, meta: { requireLogin: true } },
  { path: '/mypage/order/:id', component: MyPageOrderHistoryDetail, meta: { requireLogin: true } },
  { path: '/mypage/order/:id/cancel', component: MyPageOrderHistoryDetailCancel, meta: { requireLogin: true } },
  { path: '/mypage/order/:id/canceled', component: MyPageOrderHistoryDetailCanceled, meta: { requireLogin: true } },
  { path: '/mypage/order/:id/reorder/creditcard', component: ReorderCreditcard, meta: { requireLogin: true } },
  { path: '/mypage/order/:id/reorder/payment', component: ReorderPayment, meta: { requireLogin: true } },
  { path: '/mypage/order/:id/reorder/profile', component: ReorderProfile, meta: { requireLogin: true } },
  { path: '/mypage/subscription', component: ContractedSubscriptionListPage, meta: { requireLogin: true } },
  {
    path: '/mypage/subscription/:id',
    component: ContractedSubscriptionDetailPage,
    props: true,
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/subscription/:id/edit/payment',
    component: EditPaymentForSubscription,
    props: true,
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/subscription/:id/edit/payment/new-creditcard',
    component: NewCreditcard,
    props: (route: Route) => {
      const context: ContextToRegisterNewCreditCard = {
        title: 'お支払い情報の変更',
        path: {
          editPayment: `/mypage/subscription/${route.params.id}/edit/payment`,
        },
        ...subscriptionContext(),
      }

      return { context }
    },
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/paid-membership/plans',
    component: PaidMembershipPlansPage,
    meta: { requireLogin: true },
  },
  { path: '/mypage/catalog-register', component: CatalogRegister },
  { path: '/mypage/power-settings', component: UsualPowerSettings },
  {
    path: '/mypage/points',
    component: Point,
    meta: { requireLogin: true },
    props: () => ({
      listRepository: new ApiPointListRepository(PointService.createDefault()),
    }),
  },
  {
    path: '/mypage/paid-membership/subscription-payment-history',
    component: SubscriptionPaymentHistory,
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/edit/contact/:id',
    component: MyPageEditEachContact,
    props: {
      context: ContactOnMyPageContext.build(),
    },
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/edit/new-contact',
    component: MyPageEditNewContact,
    props: {
      context: ContactOnMyPageContext.build(),
    },
    meta: { requireLogin: true },
  },
  {
    path: '/mypage/edit/contact',
    component: MyPageEditContact,
    props: {
      context: ContactOnMyPageContext.build(),
    },
    meta: { requireLogin: true },
  },
  {
    path: '/cart/login',
    component: authViewDefinition.layout.login,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.cart.login,
      },
    }],
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['cart'],
    },
    props: propsForCartLogin,
    beforeEnter: beforeEnterCartAuth,
  },
  {
    path: '/cart/signup',
    component: authViewDefinition.layout.signup,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.cart.signup,
      },
    }],
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['cart'],
    },
    props: propsForCartSignup,
    beforeEnter: beforeEnterCartAuth,
  },
  {
    path: '/order',
    component: Order,
    props: (route) => {
      /**
       * TODO:
       * 何らかの問題でscopeクエリが与えられなかった場合、
       * toScope('') は { kind: ScopeKind.valueOf(''), value: ScopeValue.valueOf(undefined) } を返す
       *
       * この際にはOrder.vueは適切に動作できないと思われるので、以下のような手当てを入れたほうが良さそう
       * - この時点で何らかのガードを入れて、Order.vueをマウントする前にリダイレクトする
       * - Order.vueに対して明示的に「不完全なCartScopeEq」を渡す
       *   言い換えると、toScopeが明示的に「不完全なCartScopeEq」を返せるようにする
       *
       * 関連するissue:
       * https://github.com/Everforth/growthpalette-front/issues/8077
       */
      const scope = toScope(route.query.scope as string || '')
      const serviceLocator = selectOrderLocatorByScope(scope)
      const contextFactory = OnceOrderContext.build

      return { scope, contextFactory, ...serviceLocator }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/complete-profile',
    component: MinimumUpdateProfile,
    props: {
      context: OnceOrderContext.build(),
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/complete',
    component: OrderComplete,
    props: (route) => {
      const scope = toScope(route.query.scope as string || '')
      const isReorder = route.query.reorder === 'true'
      const serviceLocator = selectOrderCompleteLocatorByScope(scope)

      return {
        scope,
        isReorder,
        ...serviceLocator,
      }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/complete/:id',
    component: OrderCompleteById,
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/edit/contact',
    component: OrderEditContact,
    props: {
      context: OnceOrderContext.build(),
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/edit/contact/:id',
    component: OrderEditEachContact,
    props: {
      context: OnceOrderContext.build(),
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/edit/new-contact',
    component: OrderEditNewContact,
    props: {
      context: OnceOrderContext.build(),
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/edit/payment',
    component: OrderEditPayment,
    props: route => ({
      scope: toScope(route.query.scope as string || ''),
      context: OnceOrderContext.build(),
    }),
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/edit/payment/new-creditcard',
    component: NewCreditcard,
    props: () => {
      const context: ContextToRegisterNewCreditCard = Object.assign(
        OnceOrderContext.build(),
        purchaseContext()
      )

      return {
        context,
        reloadCreditcard: reloadCreditcardForPurchase,
      }
    },
    async beforeEnter(to: Route, _from: Route, next) {
      const scope = toScope(to.query.scope as string || '')
      const redirect = await guardOnCart({
        scope,
        redirectLocation: () => ({ path: '/carts' }),
        filter: isSinglePurchasable,
      })

      redirect ? next(redirect) : next()
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },

  {
    path: '/order/subscription/:sku_id',
    component: ApplySubscription,
    props: (route) => {
      const scope = toScope(route.query.scope as string || '')
      const serviceLocator = selectOrderLocatorByScope(scope)
      const skuId = route.params.sku_id
      const cartItemRepository: CartItemRepository = new EngineCartRepository()
      const subscriptionService = new SubscriptionService()
      const subscriptionApplyingItemRepository = new DefaultSubscriptionApplyingItemRepository(
        SubscriptionApplyingItemService.forHost
      )
      const context = SubscriptionContext.build({ skuId })

      return {
        skuId,
        scope,
        cartItemRepository,
        context,
        subscriptionService,
        subscriptionApplyingItemRepository,
        ...serviceLocator,
      }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/complete-profile',
    component: MinimumUpdateProfile,
    props: route => ({
      context: SubscriptionContext.build({
        skuId: route.params.sku_id,
      }),
    }),
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/edit/payment',
    component: SubscriptionEditPayment,
    props: (route) => {
      const scope = toScope(route.query.scope as string || '')
      const skuId = route.params.sku_id
      const context = SubscriptionContext.build({ skuId })

      return { skuId, scope, context }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/edit/payment/new-creditcard',
    component: NewCreditcard,
    props: (route) => {
      const skuId = route.params.sku_id
      const context: ContextToRegisterNewCreditCard = Object.assign(
        SubscriptionContext.build({
          skuId,
        }),
        subscriptionContext()
      )

      return {
        skuId,
        context,
        reloadCreditcard: reloadCreditcardForSubscription,
      }
    },
    async beforeEnter(to: Route, _from: Route, next) {
      const scope = toScope(to.query.scope as string || '')

      const location = await guardOnCart({
        scope,
        redirectLocation: () => ({
          path: InstanceResolver.isSingle() && scope.kind.isBrand
            ? `/${scope.kind.toString()}`
            : '/',
        }),
        filter: isSubscriptionItem,
      })

      location ? next(location) : next()
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/edit/contact',
    component: OrderEditContact,
    props: (route) => {
      const skuId = route.params.sku_id
      const context = SubscriptionContext.build({ skuId })

      return { skuId, context }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/edit/contact/:id',
    component: OrderEditEachContact,
    props: (route) => {
      const skuId = route.params.sku_id
      const context = SubscriptionContext.build({ skuId })

      return { skuId, context }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/edit/new-contact',
    component: OrderEditNewContact,
    props: (route) => {
      const skuId = route.params.sku_id
      const context = SubscriptionContext.build({ skuId })

      return { skuId, context }
    },
    meta: {
      queriesToBeKept: ['scope'],
      locationGroups: ['order'],
    },
  },
  {
    path: '/order/subscription/:sku_id/complete',
    component: SubscriptionOrderComplete,
    props: (route) => {
      const skuId = route.params.sku_id
      const scope = toScope(route.query.scope as string || '')
      const serviceLocator = selectOrderCompleteLocatorByScope(scope)
      const context = SubscriptionContext.build({ skuId })

      return { skuId, context, scope, ...serviceLocator }
    },
    meta: {
      locationGroups: ['order'],
    },
  },
  {
    path: '/paid-membership/unexpected-creditcard-register-error',
    component: UnexpectedCreditcardRegsiterError,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/paid-membership/subscribe',
    component: SubscribePaidMembership,
    props: (to: Route) => {
      const q = to.query.currentStep
      const currentStep = typeof q !== 'string' || isNaN(parseInt(q, 10))
        ? 1
        : parseInt(q, 10)

      return {
        title: '月額プログラムお申し込み',
        context: Context.valueOf(currentStep),
        creditcardRegistrationDependencies: subscriptionContext(),
      }
    },
    meta: {
      queriesToBeKept: ['return_to'],
      requireLogin: true,
    },
  },
  {
    path: '/paid-membership/:commerce_subscription_id/payment',
    component: ChangeCreditcard,
    props: () => ({
      creditcardRegistrationDependencies: subscriptionContext(),
    }),
    meta: {
      queriesToBeKept: ['return_to'],
      requireLogin: true,
    },
  },
  {
    // 保留からの再開用画面
    path: '/paid-membership/:commerce_subscription_id/restart',
    component: ChangeCreditcard,
    props: () => ({
      creditcardRegistrationDependencies: subscriptionContext(),
      subCompleteMessage: Vue.extend({
        name: 'SubCompleteMessageOnRestartHoldingPlan',
        template: `
        <p>
          決済に成功次第、プランを再開いたします。<br/>
          再開までしばらくおまちください。
        </p>
        `,
      }),
    }),
    meta: {
      queriesToBeKept: ['return_to'],
      requireLogin: true,
    },
  },
  {
    /**
     * 一時的に追加されたページであり、将来的に廃止される可能性が高い.
     * 詳細は{@link NextPageAfterCardRegistration}のコメントを参照.
     */
    path: '/paid-membership/new-creditcard',
    component: ChangeCreditcard,
    props: to => ({
      creditcardRegistrationDependencies: subscriptionContext(),
      nextPage: {
        path: to.query.next,
        label: '戻る',
      } as NextPageAfterCardRegistration,
      context: '登録' ,
    }),
    meta: {
      queriesToBeKept: ['return_to'],
      requireLogin: true,
    },
  },
  {
    path: '/paid-membership/subscribe/complete',
    component: CompleteSubscribe,
    props: {
      title: '月額プログラムお申し込み',
    },
    meta: {
      queriesToBeKept: ['return_to'],
      requireLogin: true,
    },
  },
  {
    path: '/paid-membership/unsubscribe/confirm/:planId/:subscriptionId',
    component: Confirm,
    meta: { requireLogin: true },
    props: true,
  },
  {
    path: '/paid-membership/unsubscribe/:planId/:subscriptionId',
    component: UnsubscribePaidMembership,
    meta: { requireLogin: true },
    props: true,
  },
  {
    path: '/paid-membership/:groupId/downgrade/:beforePlanId/to/:afterPlanId',
    component: ChangePlan,
    meta: { requireLogin: true },
    props: route => ({
      ...route.params,
      interaction: ChangePlanInteraction.forDowngrade({
        find: DefaultAvailableMembershipPlanGroupRepository.forHost,
        change: DefaultChangePaidMembershipPlanRepository.forHost,
      }),
      pageBuilder: downgradePageBuilder,
    }),
  },
  {
    path: '/paid-membership/:groupId/upgrade/:beforePlanId/to/:afterPlanId',
    component: ChangePlan,
    meta: { requireLogin: true },
    props: route => ({
      ...route.params,
      interaction: ChangePlanInteraction.forUpgrade({
        find: DefaultAvailableMembershipPlanGroupRepository.forHost,
        change: DefaultChangePaidMembershipPlanRepository.forHost,
      }),
      pageBuilder: upgradePageBuilder,
    }),
  },
  {
    path: '/paid-membership/subscribe/login',
    component: authViewDefinition.layout.login,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.paidMembership.login,
      },
    }],
    props: {
      next: '/s/paid-membership/subscribe',
      signupLink: '/paid-membership/subscribe/signup',
      title: '月額プログラムお申し込み',
    },
    meta: {
      queriesToBeKept: ['next'],
    },
  },
  {
    path: '/paid-membership/subscribe/signup',
    component: authViewDefinition.layout.signup,
    children: [{
      path: '',
      components: {
        ...authViewDefinition.pages.paidMembership.signup,
      },
    }],
    props: {
      next: '/s/paid-membership/subscribe',
      loginLink: '/paid-membership/subscribe/login',
      title: '月額プログラムお申し込み',
    },
    meta: {
      queriesToBeKept: ['next'],
    },
  },
  // TODO: More better way
  { path: '/webroot/s', redirect: '/login' },
]

const brandRoutes: RouteConfig[] = [
  {
    path: '/brand/:brand_english_name/cart',
    component: Cart,
    props: propsForCart(route => ({
      scope: {
        kind: ScopeKind.valueOf('brand'),
        value: ScopeValue.valueOf(route.params.brand_english_name),
      },
      context: {
        instance: multiInstanceContext,
        page: createBrandPageContext(route.params.brand_english_name),
      },
    })),
    meta: {
      locationGroups: ['cart'],
    },
    beforeEnter: guardOnBrandScope({
      extractScope: to => ({
        kind: ScopeKind.valueOf('brand'),
        value: ScopeValue.valueOf(to.params.brand_english_name),
      }),
      redirect: {
        whenOtherScopeAvailable: scope => ({
          path: `/${scope.kind.toString()}/${scope.value.toString()}/cart`,
        }),
        whenErrorOccurred: { path: '/carts' },
      },
    }),
  },
  {
    path: '/:scope_kind/:scope_value/cart',
    component: Cart,
    props: propsForCart(route => ({
      scope: {
        kind: ScopeKind.valueOf(route.params.scope_kind),
        value: ScopeValue.valueOf(route.params.scope_value),
      },
      context: {
        instance: multiInstanceContext,
        page: crossBrandPageContext,
      },
    })),
    meta: {
      locationGroups: ['cart'],
    },
    beforeEnter: guardOnCrossBrandScope({
      extractScope: to => ({
        kind: ScopeKind.valueOf(to.params.scope_kind),
        value: ScopeValue.valueOf(to.params.scope_value),
      }),
      redirect: {
        whenErrorOccurred: { path: '/carts' },
      },
    }),
  },
  /**
   * 以前はブランド単位のカートしか無かったので
   * - ブランド単位固定 → スコープ単位に変更
   *  - メインの目的はこっち
   * - 「カート画面をお気に入りしている人もいるかも？」
   *  - 多分いない気はする
   * という意味でのリダイレクト。
   *
   * 将来的には削除して、 /:kind/:value/cart に統合。
   * @see https://github.com/my-color/front/issues/3742
   */
  { path: '/:brand_english_name/cart', redirect: '/brand/:brand_english_name/cart' },
]

const fallbackRoutes: RouteConfig[] = [
  { path: '*', component: NotFound },
]

function makeRoutes(): RouteConfig[] {
  if (isSingleInstance) {
    return [
      ...commonRoutes,
      ...[
        {
          path: '/cart',
          component: Cart,
          props: propsForCart(() => ({
            scope: {
              kind: ScopeKind.valueOf('brand'),
              value: ScopeValue.valueOf(InstanceResolver.getSingleBrand()),
            },
            context: {
              instance: singleInstanceContext,
              page: hostPageContext,
            },
          })),
          meta: {
            locationGroups: ['cart'],
          },
        },
      ],
      ...fallbackRoutes,
    ]
  }

  return [
    ...commonRoutes,
    ...[{
      path: '/carts',
      component: CartList,
      meta: {
        locationGroups: ['cart'],
      },
    }],
    ...brandRoutes,
    ...fallbackRoutes,
  ]
}

const router = new Router({
  mode: 'history',
  base: '/s',
  routes: makeRoutes(),
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/order/complete') {
    next()

    return
  }

  executeUniversalTag()
  const brandEnglishName = BrandRouteResolver.resolveBrandFromPathElement(to.params.brand_english_name) || null

  /**
   * Vue Componentの生成を妨げないよう、非同期メソッドsendPcpAnalyticsLogは await しない
   * @see https://github.com/my-color/growthpalette-front/pull/7821
   */
  sendPcpAnalyticsLog(brandEnglishName).catch((err) => {
    log.error(err)
  })

  next()
})

router.beforeEach(async (to, from, next) => {
  const shouldGoToLogin = await RouteHook.requireLogin(to)

  if (shouldGoToLogin) {
    next(shouldGoToLogin)

    return
  }

  RouteHook.setLocationGroups(to)
  RouteHook.setPurchaseIntentCookie(to)

  const shouldqueriesToBeKept = RouteHook.keepQueries(to, from)

  if (shouldqueriesToBeKept) {
    next(shouldqueriesToBeKept)

    return
  }

  RouteHook.attachGroupBrand(to)

  next()
})

export default router
